<template>
  <li
    class="tag-item"
    style="white-space: nowrap; overflow: hidden"
    :style="{ 'background-color': isError ? 'red' : '', color: isError ? 'white' : '' }"
  >
    <div style="display: flex; align-items: stretch">
      <div
        class="my-handle"
        style="display: inline-block; padding: 3px 5px 3px 5px; cursor: move; margin-left: 4px"
        v-if="isDrag"
      >
        <i class="fas fa-grip-vertical"></i>
      </div>
      <div class="ignore-elements" style="display: inline-block; padding: 0">
        <div
          style="white-space: normal"
          :style="{ 'border-left': !isDrag ? '0' : 'auto' }"
          class="tag"
          ref="tagInput"
          @focus="editText = true"
          maxlength="5"
          contenteditable="true"
          @blur="onBlurInput()"
          @input="update"
          v-on:keydown.enter.prevent="pressEnter"
          v-text="text"
        ></div>
      </div>

      <div class="ignore-elements" style="display: inline-block">
        <i
          class="fas fa-remove"
          v-if="!editText"
          style="padding: 6px 5px 2px; margin-right: 4px; cursor: pointer"
          @click="$emit('onDelete')"
        ></i>
        <i
          class="fas fa-pencil-alt"
          v-else
          style="padding: 6px 5px 2px; margin-right: 4px; cursor: pointer; color: white"
          @click="onBlurInput()"
        ></i>
      </div>
    </div>
  </li>
</template>

<script>
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
export default {
  props: {
    value: '',
    isEdit: false,
    max: {
      type: Number,
      default: 0,
    },
    maxlength: {
      type: Number,
      default: 0,
    },
    isDrag: {
      type: Boolean,
    },
  },
  components: {
    AutoresizeTextarea,
  },
  data: function () {
    return {
      text: this.value,
      editText: false,
      isError: false,
    }
  },
  methods: {
    pressEnter: function (event) {
      this.onBlurInput()
    },
    onBlurInput: function () {
      var vm = this
      if (vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText) == '') {
        vm.$emit('onDelete')
        return false
      } else {
        vm.$emit(
          'onChange',
          Object.assign(
            {},
            {
              tag: {
                // status: 'edit',
                text: vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText),
              },
              addTag: function () {
                vm.$refs.tagInput.innerText = vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText)

                vm.$emit('input', vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText))
                vm.$emit('tags-changed')
                vm.editText = false
                vm.$refs.tagInput.blur()
              },
              error: function () {
                vm.isError = true
              },
            }
          )
        )
      }
    },
    update: function () {
      if (event.target.innerText.trim() == '') {
        return false
      }
      this.isError = false
    },
  },
  watch: {
    value: function (newVal, oldVal) {
      // console.log(newVal,this.$refs.tagInput.innerText)
      if (newVal != oldVal && newVal != this.$refs.tagInput.innerText) {
        this.$refs.tagInput.innerText = this.value
      }
      // this.text = this.value
    },
  },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/TagItem.vue